module.exports = __webpack_public_path__ + "img/dne-exchange.a1a21b7d.jpg";